// extracted by mini-css-extract-plugin
export default {"container":"ProgressLabel_container__BaNgt","label":"ProgressLabel_label__SL3C6","barContainer":"ProgressLabel_barContainer__ev7-r"};